<script>
  import converterMoeda from '~js/converter-moeda';
  
  export default {
    components: {
    },
    props: {
      pedido: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        item: this.camposItem(),
      }
    },
    methods: {
      camposItem() {
        return {
          id: '',
          produto: '',
          complemento: '',
          quantidadePedida: '',
          quantidadeEntregue: '',
          quantidadeCancelada: '',
          valorUnitario: '',
          valorRecebido: '',
          valorUnitarioEntregue: '',
        };
      },
      selecionar(item, index) {
        this.item.id = index;
        this.item.produto = item.produto.descricaoResumida;
        this.item.complemento = item.complementoItemPedido;
        this.item.quantidadePedida = item.quantidade;
        this.item.quantidadeEntregue = item.quantidadeRecebida ? item.quantidadeRecebida : '';
        this.item.quantidadeCancelada = item.quantidadeCancelada ? item.quantidadeCancelada : '';
        this.item.valorUnitarioEntregue = item.valorUnitarioEntregue ? item.valorUnitarioEntregue : '';
        this.item.valorUnitario = item.valorUnitario;
        this.item.valorRecebido = item.quantidadeRecebida ? this.valorTotalItemRecebido(item) : '0,00';

        if (this.pedido.servico)
          this.item.quantidadeEntregue = '1,00';
        else
          $('#quantidadeEntregue').removeAttr('disabled');

        $('#quantidadeCancelada').removeAttr('disabled');
        $('#valorUnitarioEntregue').removeAttr('disabled');
        $('#salvarItem').removeAttr('disabled');
        this.$validator.reset();
      },
      validaQuantidades(valido) {
        if (!valido) throw new Error("validacao com erro");

        var quantidade = 0;
        var quantidadeRecebida = 0;
        var quantidadeCancelada = 0;

        if (this.item.quantidadePedida)
          quantidade = this.$options.filters.formatarNumero(this.item.quantidadePedida, true);

        if (this.item.quantidadeEntregue)
          quantidadeRecebida = this.$options.filters.formatarNumero(this.item.quantidadeEntregue, true);

        if (this.item.quantidadeCancelada)
          quantidadeCancelada = this.$options.filters.formatarNumero(this.item.quantidadeCancelada, true);

        if ((quantidade - quantidadeCancelada - quantidadeRecebida) >= 0) return true;

        this.$swal(
          '',
          'A (Quantidade pedida - Quantidade recebida - Quantidade cancelada) tem que ser igual a zero ',
          'info'
        );

        throw new Error("validacao");
      },
      validaValores(valido) {
        if (!valido) throw new Error("validacao com erro");


        if (!this.pedido.servico)
          return true;

        var valorUnitario = 0;
        var valorUnitarioEntregue = 0;

        if (this.item.valorUnitario)
          valorUnitario = this.$options.filters.formatarNumero(this.item.valorUnitario, true);

        if (this.item.valorUnitarioEntregue)
          valorUnitarioEntregue = this.$options.filters.formatarNumero(this.item.valorUnitarioEntregue, true);

        if ((valorUnitario - valorUnitarioEntregue) >= 0) return true;

        this.$swal(
          '',
          'O (Valor unitario pedido - Valor unitario entregue) tem que ser igual a zero ',
          'info'
        );

        throw new Error("validacao");
      },
      salvarItem() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");

            return valido;
          })
          .then(this.validaQuantidades)
          .then(this.validaValores)
          .then(this.substituirItem)
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      substituirItem() {
        const copiaItem = Object.assign(this.pedido.itensPedidoCompra[this.item.id]);

        const quantidadeRecebida = this.$options.filters.formatarNumero(this.item.quantidadeEntregue, true);
        const quantidadeCancelada = this.$options.filters.formatarNumero(this.item.quantidadeCancelada, true);
        const valorUnitarioEntregue = this.$options.filters.formatarNumero(this.item.valorUnitarioEntregue, true);

        this.$set(copiaItem, 'quantidadeRecebida', converterMoeda.paraReal(quantidadeRecebida));
        this.$set(copiaItem, 'quantidadeCancelada', converterMoeda.paraReal(quantidadeCancelada));
        this.$set(copiaItem, 'valorUnitarioEntregue', converterMoeda.paraReal(valorUnitarioEntregue));

        this.pedido.itensPedidoCompra.splice(this.item.id, 1);
        this.pedido.itensPedidoCompra.push(copiaItem);

        this.resetaCampoItens();
        this.$validator.reset();
      },
      resetaCampoItens() {
        this.item = this.camposItem();
        $('#quantidadeEntregue').attr('disabled','');
        $('#quantidadeCancelada').attr('disabled', '');
        $('#valorUnitarioEntregue').attr('disabled', '');
        $('#salvarItem').attr('disabled','disabled');
      },
      validarItens() {
        if (this.totalPedidoRecebido < 0)
          return false;

        return ((this.totalPedidoRecebido - this.$options.filters.formatarNumero(this.pedido.valorFrete, true)
                                          + this.$options.filters.formatarNumero(this.pedido.descontoPedido, true)) > 0.01);
      },
      valorTotalItemRecebido(item) {
        const quantidade = this.$options.filters.formatarNumero(item.quantidadeRecebida, true);
        var valorUnitario = 0;

        if (!this.pedido.servico)
          valorUnitario += this.$options.filters.formatarNumero(item.valorUnitario, true);
        else
          valorUnitario += this.$options.filters.formatarNumero(item.valorUnitarioEntregue, true);

        let valor = (quantidade * valorUnitario);

        return converterMoeda.paraReal(valor);
      },
      valorTotalItem(item) {
        const quantidade = this.$options.filters.formatarNumero(item.quantidade, true);
        const valorUnitario = this.$options.filters.formatarNumero(item.valorUnitario, true);
        const ipi = this.$options.filters.formatarNumero(item.ipiItemPedido, true);
        const desconto = this.$options.filters.formatarNumero(item.descontoDinheiro, true);

        let valor = (quantidade * valorUnitario);

        valor += (valor * ipi / 100);

        valor -= desconto;

        return converterMoeda.paraReal(valor);
      },
      valorTotalItemRecebidoComputado() {
        const quantidade = this.$options.filters.formatarNumero(this.item.quantidadeEntregue, true);
        var valorUnitario = 0;

        if (!this.pedido.servico)
          valorUnitario += this.$options.filters.formatarNumero(this.item.valorUnitario, true);
        else
          valorUnitario += this.$options.filters.formatarNumero(this.item.valorUnitarioEntregue, true);

        let valor = (quantidade * valorUnitario);

        this.item.valorRecebido =  converterMoeda.paraReal(valor);
      },
    },
    computed: {
      totalPedidoRecebido() {
        let valor = this.pedido.itensPedidoCompra.reduce((somatorio, item) => {
                      const quantidade = this.$options.filters.formatarNumero(item.quantidadeRecebida, true);
                      var valorUnitario = 0;

                      if (!this.pedido.servico)
                        valorUnitario += this.$options.filters.formatarNumero(item.valorUnitario, true);
                      else
                        valorUnitario += this.$options.filters.formatarNumero(item.valorUnitarioEntregue, true);
                      
                      let valor = (quantidade * valorUnitario);

          return somatorio + valor
        }, 0);

        return valor + this.$options.filters.formatarNumero(this.pedido.valorFrete, true)
                     - this.$options.filters.formatarNumero(this.pedido.descontoPedido, true);
      },
    },
    mounted() {
      $('#salvarItem').attr('disabled','disabled');  
    }
  }
</script>

<template>
  <div>
    <div class="ibox-footer">
      <div class="table-responsive">
        <table class="table table-bordered table-hover table-pointer table-column-code table-column-action">
          <thead v-if="pedido.itensPedidoCompra.length > 0">
            <tr>
              <th>Produto</th>
              <th>Complemento</th>
              <th>Qtd pedida</th>
              <th>Valor unit&aacute;rio</th>
              <th>Valor total</th>
              <th>Qtd entregue</th>
              <th v-if="!pedido.servico">Qtd cancelada</th>
              <th v-if="pedido.servico">Valor unit. entregue</th>
              <th>Valor total recebido</th>
            </tr>
          </thead>
          <tbody v-if="pedido.itensPedidoCompra.length > 0">
            <tr v-for="(item, index) in pedido.itensPedidoCompra" @click="selecionar(item, index)">
              <td>{{ item.produto ? item.produto.descricaoResumida : '---' }}</td>
              <td>{{ item.complementoItemPedido.length > 300 ? item.complementoItemPedido.substring(0, 300) : item.complementoItemPedido.substring(0, item.complementoItemPedido.length) }} (...)</td>
              <td>{{ item.quantidade }}</td>
              <td>{{ item.valorUnitario }}</td>
              <td>{{ valorTotalItem(item) }}</td>
              <td>{{ item.quantidadeRecebida == 0 ? '0,00' : item.quantidadeRecebida   }}</td>
              <td v-if="!pedido.servico">{{ item.quantidadeCancelada == 0 ? '0,00' : item.quantidadeCancelada  }}</td>
              <td v-if="pedido.servico">{{ item.valorUnitarioEntregue == 0 ? '0,00' : item.valorUnitarioEntregue  }}</td>
              <td>{{ valorTotalItemRecebido(item) == 0 ? '0,00' : valorTotalItemRecebido(item)  }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="8"><small>Clique sobre o item para seleciona-lo.</small></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="bs-callout bs-callout-primary">
      <h4>Valor total recebido    (valor + frete\acr&eacute;scimo - desconto): R$ {{ totalPedidoRecebido | formatarNumero }}</h4>
    </div>

    <div class="hr-line-dashed margin-top-5"></div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <label class="control-label" for="produto">Produto</label>

          <input type="text"
                 class="form-control"
                 id="produto"
                 v-model="item.produto"
                 disabled>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <label class="control-label" for="complemento">Complemento</label>

          <textarea class="form-control"
                    id="complemento"
                    v-model="item.complemento"
                    disabled>
         </textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label" for="quantidadePedida">Quantidade pedida</label>

          <input type="text"
                 class="form-control text-right"
                 id="quantidadePedida"
                 v-mascara="'moeda'"
                 v-model="item.quantidadePedida"
                 disabled>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label" for="valorUnitario">Valor unit&aacute;rio (R$)</label>

          <input type="text"
                 class="form-control text-right"
                 id="valorUnitario"
                 v-mascara="'moeda'"
                 v-model="item.valorUnitario"
                 disabled>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('quantidadeEntregue')}">
          <label class="control-label" for="quantidadeEntregue">Quantidade entregue</label>

          <input type="text"
                 class="form-control text-right"
                 id="quantidadeEntregue"
                 v-mascara="'moeda'"
                 v-model="item.quantidadeEntregue"
                 data-vv-name="quantidadeEntregue"
                 data-vv-as="quantidade entregue"
                 @change="valorTotalItemRecebidoComputado"
                 v-validate="'required'"
                 disabled>

          <p class="text-danger" v-show="errors.has('quantidadeEntregue')">{{ errors.first('quantidadeEntregue') }}</p>
        </div>
      </div>

      <div class="col-lg-2" v-if="!pedido.servico">
        <div class="form-group required" :class="{'has-error': errors.has('quantidadeCancelada')}">
          <label class="control-label" for="quantidadeCancelada">Quantidade cancelada</label>

          <input type="text"
                 class="form-control text-right"
                 id="quantidadeCancelada"
                 v-mascara="'moeda'"
                 v-model="item.quantidadeCancelada"
                 data-vv-name="quantidadeCancelada"
                 data-vv-as="quantidade cancelada"
                 v-validate="'required'"
                 disabled>

          <p class="text-danger" v-show="errors.has('quantidadeCancelada')">{{ errors.first('quantidadeCancelada') }}</p>
        </div>
      </div>

      <div class="col-lg-2" v-if="pedido.servico">
        <div class="form-group required" :class="{'has-error': errors.has('valorUnitarioEntregue')}">
          <label class="control-label" for="valorUnitarioEntregue">Valor unit. entregue</label>
          
          <input type="text"
                 class="form-control text-right"
                 id="valorUnitarioEntregue"
                 v-mascara="'moeda'"
                 v-model="item.valorUnitarioEntregue"
                 data-vv-name="valorUnitarioEntregue"
                 data-vv-as="valor unitario entregue"
                 @change="valorTotalItemRecebidoComputado"
                 v-validate="'required'"
                 disabled>

          <p class="text-danger" v-show="errors.has('valorUnitarioEntregue')">{{ errors.first('valorUnitarioEntregue') }}</p>
        </div>
      </div>

      <div class="col-lg-3">
        <div class="form-group">
          <label class="control-label" for="valorRecebido">Valor recebido (R$)</label>

          <input type="text"
                 class="form-control text-right"
                 id="valorRecebido"
                 v-mascara="'moeda'"
                 v-model="item.valorRecebido"
                 disabled>
        </div>
      </div>

      <div class="col-lg-1">
        <div class="form-group" style="padding-top: 22px;">
          <button id="salvarItem"
                  type="button"
                  class="btn btn-primary"
                  @click="salvarItem"
                  data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
            <i class="fa fa-save"></i>
            Substituir
          </button>

        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/pedido/componentes/compartilhado/FormPedidoItens.vue